'use strict';

require('custom-event-polyfill');

require('usertiming');

require('navigator.sendbeacon');


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/polyfills.js
// module id = 514
// module chunks = 5